<div class="w3-container w3-contenedor-template" style="height: 7vh;">
  <div class="w3-row ">
    <!-- TITULO DEL COMPONENTE -->
    <div class="w3-quarter padreizquierda ">
      <div class="w3-row hijoizquierda">
        <!--<span class="w3-text-deep-orange w3-margin-right-filter"><b>{{ dataService.currentModule }} </b></span>-->
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"><b> {{'menu.'+dataService.moduleSelect | translate}} </b></span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class=" w3-margin-left-filter w3-text-orange w3-subtituloPrincipal">{{ 'menu.'+dataService.subModuleSelect | translate }}</span>
      </div>
    </div>
    <!-- FIN TITULO DEL COMPONENTE -->
    <!-- FILTROS-->
    <div class="w3-rest">
      <!-- AÑOS -->
      <div class="w3-veinte">
        <app-filters
          [array]="aniosDisponibles"
          [typeFilter]="Filtros.YEAR"
          [name]="'filtros.anio' | translate"
          (eventClick)="anioChange($event)"
          [click]="false"
        ></app-filters>
      </div>
      <!-- FIN AÑOS -->

      <!-- MESES -->
      <div class="w3-quarter">
        <app-filters
          [array]="mesesDisponibles"
          [typeFilter]="Filtros.MOUNTH"
          [name]="'filtros.mes' | translate"
          (eventClick)="mesChange($event);"
          [click]="false"
        ></app-filters>
      </div>
      <!-- FIN MESES -->
       <!-- NUMERO PERIODOS -->
      <div class="w3-veinte">
        <app-filters 
          [name]="'filtros.ana' | translate"
          [array]="analisis"
          [typeFilter]="Filtros.PERSPECTIVES"
          [click]="false"
          (eventClick)="cambioAnalisis($event)">
        </app-filters>
      </div>
      <!-- NUMERO PERIODOS -->
      <div class="w3-veinte">
        <app-filters 
          [name]="'filtros.nPeriodo' | translate"
          [array]="numPeriodos"
          [typeFilter]="Filtros.PERSPECTIVES"
          [click]="false"
          (eventClick)="cambioNumPeriodo($event)">
        </app-filters>
      </div>
      <!-- BORRAR FILTROS -->
      <div class="w3-rest padreizquierda w3-right">
        <div class="w3-row hijoizquierda">
          <div class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="quitarFiltros()" style="transform: scale(0.9);" matTooltip="{{'tooltips.borrar-filtros'|translate}}">
              <img src="./../../../../assets/img/eraser.png">
          </div>
        </div>
      </div>
      <!-- FIN BORRAR FILTROS -->
    </div>
    <!-- FIN FILTROS-->
  </div>
</div>

<div class="w3-container w3-contenedor-template " style="height: 85vh;">
<div class="w3-row w3-contenedor-template " style="height: 41vh;">
  <!-- PARTE DE ARRIBA -->
  <div class="w3-row w3-white" style="height: 100%;" id="Zona1">
    <!-- PARTE DE ARRIBA, HEADER DEL COMPONENTE Y FILTROS -->
    <div class="w3-row w3-white w3-header-cuadrante " style="height: 6vh;" id="titulo">
      <div class="w3-noventa w3-titulo-contenidomenu padreizquierda">
        <div class="hijoizquierdaTitle">
          <span class="w3-margin-left-contenido">{{'riesgo-credito.cosechas.tit' + tipoVista|translate}} @if(tipoVista === 'Saldo'){{{milTab1}}}</span>
          <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
          <span class=" w3-margin-left-filter w3-subtitulo">{{subtituloGrafica}}</span>
        </div>
      </div>
      <div class="w3-rest w3-right-align_rest ">
        <div class="w3-right hijoderechaTitle">
          @if (barras1) {            
            @if(!showLabels){
              <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" 
                (click)="showLabels = !showLabels"  matTooltip="{{'graf.activar'|translate}}">label</mat-icon>
            }@else {
              <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" 
                (click)="changeLabel = !changeLabel"  matTooltip="{{'graf.etiquetas'|translate}}">new_label</mat-icon>
              <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" 
              (click)="showLabels = !showLabels"  matTooltip="{{'graf.desactivar'|translate}}">label_off</mat-icon>
            }
          }
          <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" (click)="ampliar('tabla1')">zoom_out_map</mat-icon>
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menu">more_vert</mat-icon>
        </div>
        <mat-menu #menu="matMenu">
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="salOpor">
            <span>{{'menu.mostrar'|translate}}</span>
          </button>
          <mat-divider></mat-divider>
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="graficas">
            <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">assessment</mat-icon>
            <span>{{'menu.graficas'|translate}}</span>
          </button>
          @if (tipoVista === 'Saldo') {
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="moneda2">
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">paid</mat-icon>
              @if(smMoneda === '$' && idInstitucion !== 2006){<span>{{ 'menu.milesUsd' | translate}}</span>}
              @if(smMoneda === '$' && idInstitucion === 2006){<span>{{ 'menu.milesMxn' | translate}}</span>}
              @if(smMoneda === 'Gs'){<span>{{ 'menu.milesGs' | translate}}</span>}              
              @if(smMoneda === 'Q'){<span>{{ 'menu.milesQ' | translate}}</span>} 
            </button>
          }          
          <div mat-menu-item [matMenuTriggerFor]="menuP.perspectivas" #trigger="matMenuTrigger">
            <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">account_tree</mat-icon>
            <span>{{'menu.Perspectivas'|translate}}</span>
          </div>
          <app-menu-perspectivas #menuP 
                  [tipo]="submenus" 
                  [tablero]="'cosechas'"
                  (eventClick)="filterChange($event);">
          </app-menu-perspectivas>
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="par">
            <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">density_medium</mat-icon>
            <span>{{'menu.par'|translate}}</span>
          </button>
          <mat-divider></mat-divider>
          @if (tabla1) {
            <button mat-menu-item (click)="export_csv(1)">
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">description</mat-icon>
              <span>{{'menu.exportar' | translate}}</span>
            </button>
          }@else{
            <button mat-menu-item (click)="export_img(1)">
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">image</mat-icon>
              <span>{{'menu.exportar' | translate}}</span>
            </button>
          }   
          
          <!-- BOTON ELIMINAR FILTROS -->
          @if (perspectiva) {
            <button (click)="quitarFiltros()" class="mat-menu-item " mat-menu-item>
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">
                <img style="margin-top: -10px;" src="assets/img/graficos/sinfiltro.png">
              </mat-icon>
              <span>{{'filtros.eliminar' | translate}}</span>
            </button>
          }          
        </mat-menu>
        <mat-menu #moneda2="matMenu">
          <button mat-menu-item (click)="CambMon('Mil',1)">
            <span>{{'menu.miles' | translate}}</span>
          </button>
          <button mat-menu-item (click)="CambMon('Pesos',1)">
            @if(smMoneda === '$' && idInstitucion !== 2006){<span>{{ 'menu.usd' | translate}}</span>}
            @if(smMoneda === '$' && idInstitucion === 2006){<span>{{ 'menu.mxn' | translate}}</span>}
            @if(smMoneda === 'Q'){<span>{{ 'menu.q' | translate}}</span>} 
            @if(smMoneda === 'Gs'){<span>{{ 'menu.gs' | translate}}</span>} 
          </button>
        </mat-menu>
        <mat-menu #salOpor="matMenu">
          <button mat-menu-item (click)="MostrarPor('Saldo')">
            <span>{{'menu.saldo' | translate}}</span>
          </button>
          <button mat-menu-item (click)="MostrarPor('Mora')">
            <span>{{'menu.porcentajeMora' | translate}}</span>
          </button>
          <button mat-menu-item (click)="MostrarPor('Colocacion')">
            <span>{{'menu.porcentajeColocacion' | translate}}</span>
          </button>
        </mat-menu>
        <mat-menu #graficas="matMenu">
          <button mat-menu-item (click)="Graficas1('T')">
            <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
            <span>{{'graf.tabla' | translate}}</span>
          </button>
          <button mat-menu-item (click)="Graficas1('L')">
            <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
            <span>{{'graf.lineal' | translate}}</span>
          </button>
        </mat-menu>
        <mat-menu #par="matMenu">
          <button mat-menu-item (click)="cambiarPar(8)">
            <span>8</span>
          </button>
          <button mat-menu-item (click)="cambiarPar(15)">
            <span>15</span>
          </button>
          <button mat-menu-item (click)="cambiarPar(30)">
            <span>30</span>
          </button>
          <button mat-menu-item (click)="cambiarPar(60)">
            <span>60</span>
          </button>
        </mat-menu>
      </div>
    </div>
    <!-- FIN PARTE DE ARRIBA, HEADER DEL COMPONENTE Y FILTROS -->
    <!-- PARTE DE ARRIBA, CONTENDOR DE LAS GRAFICAS -->
    <div class="w3-row">
        <!-- PARTE DE ARRIBA, HEADER DEL COMPONENTE Y FILTROS -->
        <div class="w3-row w3-white" style="height: 35vh; overflow: visible;">
            <div class="w3-encabezado-table" [ngClass]="{'visible': barras1}">
              @if (tabla1) {
                <div class="w3-scroll w3-table-all">
                  <table class="w3-table">
                    <thead>
                      <tr class="w3-table-titleLow w3-center" style="line-height: 1.2;">
                        <th class="stikyColum w3-border-right-balance">{{'riesgo-credito.cosechas.tit1' | translate}}</th>
                        <th class="stikyColum w3-border-right-balance">{{'riesgo-credito.cosechas.tit2' | translate}}</th>
                        @for(nombreMes of nombres_mes; track nombreMes; let i = $index){
                          @if(analisis[0].check){<th class="stikyColum w3-border-right-balance">{{nombreMes}}</th>}
                          @else{<th class="stikyColum w3-border-right-balance">mes {{i}}</th>}
                        }
                      </tr>
                    </thead>
                    @for(element of dataSource; track element; let i = $index){
                      <tbody>
                        <tr class="w3-table-trtd w3-center borderInf">
                          <td class="borderAllLow marginsH alinLeft"> {{element.cosecha}} </td>
                          <td class="borderAllLow marginsH  w3-right-align"> {{formatearnormal(element.montocolocado)}} </td>
                          @for (mes of element.meses; track mes; let j = $index) {
                            <td style="width: 7%;" [class]="pintar(i,nPeriodosSel-1-j)" [ngStyle]="{'color': colorText(mes)}" class="borderAllLow marginsH">
                              @if (pintarPorcent(mes) && tipoVista !== 'Saldo') {
                                <span style="font-weight: bold;" [matTooltip]="analisis[0].check ? ('tooltips.tooltipDbclick' | translate) : ''" (dblclick)="analisis[0].check ? clickTab(nombres_mes[j], element.cosecha,1):''" class="w3-button">{{mes}} %</span>
                              }
                              @if (pintarPorcent(mes) && tipoVista === 'Saldo') {
                                <span [matTooltip]="analisis[0].check ? ('tooltips.tooltipDbclick' | translate) : ''" (dblclick)="analisis[0].check ? clickTab(nombres_mes[j], element.cosecha,1):''" class="w3-button">{{mes}} </span>
                              }
                            </td>
                          }                          
                        </tr>
                      </tbody>
                    }
                  </table>
                </div>
              }
              @if (barras1) {
                <div style="height: 34vh;overflow: visible;">
                  <app-graficador 
                    [etiquetas]="showLabels"
                    [data]="dataBarrasMor"
                    [labels]="etiquetas"
                    [type]="tipoGraf"
                    [axisX]="xAxisLabel"
                    [axisY]="yAxisLabel"
                    [zona]="1"
                    [colors]="colorScheme"
                    [formatEtiquetas]="true"
                    [changeLabel]="changeLabel"
                    [legend]="{enabled: true, position: 'right'}"
                  ></app-graficador>
                </div>
              }              
            </div>
        </div>
    </div>
</div>
<!-- PARTE DE ABAJO -->
<div class="w3-row w3-white" style="height: 100%;" id="Zona2">
    <!-- PARTE DE ABAJO, HEADER DEL COMPONENTE Y FILTROS -->
    <div class="w3-row w3-white w3-header-cuadrante " style="height: 6vh;">
      <div class="w3-noventa w3-titulo-contenidomenu padreizquierda">
        <div class="hijoizquierdaTitle">
          @if (!tabla2) {
            <span class="w3-margin-left-contenido">{{'riesgo-credito.cosechas.enc2' | translate}}</span>
          }@else {
            <span class="w3-margin-left-contenido">{{'riesgo-credito.cosechas.enc2' | translate}} {{milTab2}}</span>
          }
          <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
          <span class=" w3-margin-left-filter w3-subtitulo">{{subtituloGrafica2}}</span>
        </div>
      </div>
      <div class="w3-rest w3-right-align_rest ">
        <div class="w3-right hijoderechaTitle">
          @if (barras2) {            
            @if(!showLabels2){
              <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" 
                (click)="showLabels2 = !showLabels2"  matTooltip="{{'graf.activar'|translate}}">label</mat-icon>
            }@else {
              <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" 
                (click)="changeLabel2 = !changeLabel2"  matTooltip="{{'graf.etiquetas'|translate}}">new_label</mat-icon>
              <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" 
              (click)="showLabels2 = !showLabels2"  matTooltip="{{'graf.desactivar'|translate}}">label_off</mat-icon>
            }
          }
          <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" (click)="ampliar('tabla2')">zoom_out_map</mat-icon>
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menu2">more_vert</mat-icon>
        </div>
        <mat-menu #menu2="matMenu">
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="graficas2">
            <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">assessment</mat-icon>
            <span>{{'menu.graficas' | translate}}</span>
          </button>
          @if (tabla2) {
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="moneda">
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">paid</mat-icon>
              @if(smMoneda === '$' && idInstitucion !== 2006){<span>{{ 'menu.milesUsd' | translate}}</span>}
              @if(smMoneda === '$' && idInstitucion === 2006){<span>{{ 'menu.milesMxn' | translate}}</span>}
              @if(smMoneda === 'Gs'){<span>{{ 'menu.milesGs' | translate}}</span>} 
              @if(smMoneda === 'Q'){<span>{{ 'menu.milesQ' | translate}}</span>} 
            </button>
          }         
          <div mat-menu-item [matMenuTriggerFor]="menuP2.perspectivas" #trigger="matMenuTrigger">
            <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">account_tree</mat-icon>
            <span>{{'menu.Perspectivas'|translate}}</span>
          </div>
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="par">
            <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">density_medium</mat-icon>
            <span>{{'menu.par'|translate}}</span>
          </button>
          <app-menu-perspectivas #menuP2 
                  [tipo]="submenus" 
                  [tablero]="'cosechas'"
                  (eventClick)="filterChange2($event);">
          </app-menu-perspectivas>
          <mat-divider></mat-divider>
          @if (tabla2) {
            <button mat-menu-item (click)="export_csv(2)">
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">description</mat-icon>
              <span>{{'menu.Exportar' | translate}}</span>
            </button>
          }@else {
            <button mat-menu-item (click)="export_img(2)">
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">image</mat-icon>
              <span>{{'menu.Exportar' | translate}}</span>
            </button>
          }
          <!-- BOTON ELIMINAR FILTROS -->
           @if (perspectiva) {
            <button (click)="quitarFiltros()" class="mat-menu-item " mat-menu-item>
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">
                <img style="margin-top: -10px;" src="assets/img/graficos/sinfiltro.png">
              </mat-icon>
              <span>{{'filtros.eliminar' | translate}}</span>
            </button>
           }          
        </mat-menu>          
        <mat-menu #moneda="matMenu">
          <button mat-menu-item (click)="CambMon('Mil',2)">
            <span>{{'menu.miles' | translate}}</span>
          </button>
          <button mat-menu-item (click)="CambMon('Pesos',2)">
            @if(smMoneda === '$' && idInstitucion !== 2006){<span>{{ 'menu.usd' | translate}}</span>}
            @if(smMoneda === '$' && idInstitucion === 2006){<span>{{ 'menu.mxn' | translate}}</span>}
            @if(smMoneda === 'Gs'){<span>{{ 'menu.gs' | translate}}</span>} 
            @if(smMoneda === 'Q'){<span>{{ 'menu.q' | translate}}</span>} 
          </button>
        </mat-menu>
        <mat-menu #graficas2="matMenu">
          <button mat-menu-item (click)="Graficas2('T')">
            <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
            <span>{{'graf.tabla' | translate}}</span>
          </button>
          <button mat-menu-item (click)="Graficas2('L')">
            <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
            <span>{{'graf.lineal' | translate}}</span>
          </button>
        </mat-menu>
      </div>
    </div>
    <!-- FIN PARTE DE ABAJO, HEADER DEL COMPONENTE Y FILTROS -->

    <!-- PARTE DE ABAJO, CONTENDOR DE LAS GRAFICAS -->
    <div class="w3-row" >
        <!-- PARTE DE ABAJO, HEADER DEL COMPONENTE Y FILTROS -->
        <div class="w3-row w3-white" style="height: 35vh">
            <div class="w3-encabezado-table w3-scroll" [ngClass]="{'visible': barras2}">
                @if (tabla2) {
                  <div>
                    <table class="w3-table">
                      <thead>
                        <tr class="w3-table-titleLow w3-center" style="line-height: 1.2;">
                          <th class="stikyColum w3-border-right-balance">{{'riesgo-credito.cosechas.tit1' | translate}}</th>
                          <th class="stikyColum w3-border-right-balance">{{'riesgo-credito.cosechas.tit2' | translate}}</th>
                          @for(nombreMes of nombres_mes; track nombreMes; let i = $index){
                            @if(analisis[0].check){<th class="stikyColum w3-border-right-balance" >{{nombreMes}}</th>}
                            @else{<th class="stikyColum w3-border-right-balance">mes {{i}}</th>}
                          }
                        </tr>
                      </thead>
                      @for(element of dataSource2; track element; let i = $index){
                        <tbody>
                          <tr class="w3-table-trtd w3-center borderInf">
                            <td class="borderAllLow marginsH alinLeft"> {{element.cosecha}} </td>
                            <td class="borderAllLow marginsH  w3-right-align"> {{formatearnormal(element.montocolocado)}} </td>
                            @for (mes of element.meses; track mes; let j = $index) {
                              <td style="width: 7%;" [class]="pintar(i,nPeriodosSel-1-j)" [ngStyle]="{'color': colorText(mes)}" class="borderAllLow marginsH w3-right-align">
                                <span [matTooltip]="analisis[0].check ? ('tooltips.tooltipDbclick' | translate) : ''" (dblclick)="analisis[0].check ? clickTab(nombres_mes[j], element.cosecha,2) : ''" class="w3-button">{{mes}} </span>
                              </td>
                            }                          
                          </tr>
                        </tbody>
                      }
                    </table>
                  </div>
                }
                @if (barras2) {
                  <div style="height: 34vh;"> 
                    <app-graficador 
                      [etiquetas]="showLabels2"
                      [data]="dataBarrasSald"
                      [labels]="etiquetas2"
                      [type]="tipoGraf"
                      [axisX]="xAxisLabel"
                      [axisY]="yAxisLabel2"
                      [zona]="2"
                      [colors]="colorScheme"
                      [formatEtiquetas]="true"
                      [changeLabel]="changeLabel2"
                      [legend]="{enabled: true, position: 'right'}"
                    ></app-graficador>
                  </div>
                }                
            </div>
        </div>
    </div>
</div>
</div>

<!-- The Modal -->
<div id="graficasModal" class="w3-modal">
  <div class="w3-modal-content" id="grafImg" style="width: 90%">
    <div class="w3-row w3-titulo-contenidomenu w3-header-cuadrante">
      <div class="w3-twothird" style="height: 100% ; margin-top: 10px; margin-left: 20px;">
        <div class="hijoizquierdaTitle">
          @if(tabla1Modal){
            <span class="w3-margin-left-contenido"><b>{{'riesgo-credito.cosechas.tit' + tipoVista|translate}} @if(tipoVista === 'Saldo'){{{milTab1}}}</b>
            </span><span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
            <span class=" w3-margin-left-filter w3-subtitulo">{{subtituloGraficaModal}}</span>
          }
          @if(tabla2Modal){
            <span class="w3-margin-left-contenido">{{'riesgo-credito.cosechas.enc2' | translate}} {{milTab2}}</span>
            <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
            <span class=" w3-margin-left-filter w3-subtitulo">{{subtituloGraficaModal}}</span>
          }
        </div>
      </div>
      <div class="w3-rest w3-right-align_rest ">
        <div class="w3-right hijoderechaTitle" style="margin-right: 20px;">
          @if (barras1Modal) {            
            @if(!showLabels){
              <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" 
                (click)="showLabels = !showLabels"  matTooltip="{{'graf.activar'|translate}}">label</mat-icon>
            }@else {
              <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" 
                (click)="changeLabel = !changeLabel"  matTooltip="{{'graf.etiquetas'|translate}}">new_label</mat-icon>
              <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" 
              (click)="showLabels = !showLabels"  matTooltip="{{'graf.desactivar'|translate}}">label_off</mat-icon>
            }
          }
          @if (barras2Modal) {            
            @if(!showLabels2){
              <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" 
                (click)="showLabels2 = !showLabels2"  matTooltip="{{'graf.activar'|translate}}">label</mat-icon>
            }@else {
              <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" 
                (click)="changeLabel2 = !changeLabel2"  matTooltip="{{'graf.etiquetas'|translate}}">new_label</mat-icon>
              <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" 
              (click)="showLabels2 = !showLabels2"  matTooltip="{{'graf.desactivar'|translate}}">label_off</mat-icon>
            }
          }
          @if (barras1Modal || barras2Modal) {
            <mat-icon class="w3-button w3-dropdown-click" style="margin-right: 3px;"[ngStyle]="{'color':'gray'}" 
            (click)="export_img(barras1Modal ? 1 : 2)" matTooltip="{{'menu.exportar' | translate}}">image</mat-icon>
          }    
          @if (tabla1Modal || tabla2Modal) {
            <mat-icon class="w3-button w3-dropdown-click" style="margin-right: 3px;"[ngStyle]="{'color':'gray'}" 
            (click)="export_csv(tabla1Modal?1:2)" matTooltip="{{'menu.exportar' | translate}}">description</mat-icon>
          }    
          <mat-icon class="w3-button w3-dropdown-click" style="margin-right: 10px; margin-left: 10px;" [ngStyle]="{'color':'gray'}" (click)="cerrarAmp()"
           onclick="document.getElementById('graficasModal').style.display='none'">clear</mat-icon>
        </div>
      </div>
    </div>
    <div class="w3-row" style="height: 65vh;">
      <div class="w3-row w3-margin" style="height: 56vh; width: 98%;">
        @if (tabla1Modal) {
          <div class="w3-encabezado-table w3-scroll">
            <table class="w3-table">
              <thead>
                <tr class="w3-table-titleLow w3-center" style="line-height: 1.2;">
                  <th class="stikyColum w3-border-right-balance">{{'riesgo-credito.cosechas.tit1' | translate}}</th>
                  <th class="stikyColum w3-border-right-balance">{{'riesgo-credito.cosechas.tit2' | translate}}</th>
                  @for(nombreMes of nombres_mes; track nombreMes; let i = $index){
                    @if(analisis[0].check){<th class="stikyColum w3-border-right-balance" >{{nombreMes}}</th>}
                    @else{<th class="stikyColum w3-border-right-balance">mes {{i}}</th>}
                  }
                </tr>
              </thead>
              @for(element of dataSource; track element; let i = $index){
                <tbody>
                  <tr class="w3-table-trtd w3-center borderInf">
                    <td class="borderAllLow marginsH alinLeft"> {{element.cosecha}} </td>
                    <td class="borderAllLow marginsH  w3-right-align"> {{formatearnormal(element.montocolocado)}} </td>
                    @for (mes of element.meses; track mes; let j = $index) {
                      <td style="width: 7%;" [class]="pintar(i,nPeriodosSel-1-j)" [ngStyle]="{'color': colorText(mes)}" class="borderAllLow marginsH">
                        @if (pintarPorcent(mes) && tipoVista !== 'Saldo') {
                          <span class="w3-button">{{mes}} %</span>
                        }
                        @if (pintarPorcent(mes) && tipoVista === 'Saldo') {
                          <span class="w3-button">{{mes}} </span>
                        }
                      </td>
                    }                          
                  </tr>
                </tbody>
              }
            </table>
          </div>
        }
        @if (tabla2Modal) {
          <div class="w3-encabezado-table w3-scroll">
            <table class="w3-table">
              <thead>
                <tr class="w3-table-titleLow w3-center" style="line-height: 1.2;">
                  <th class="stikyColum w3-border-right-balance">{{'riesgo-credito.cosechas.tit1' | translate}}</th>
                  <th class="stikyColum w3-border-right-balance">{{'riesgo-credito.cosechas.tit2' | translate}}</th>
                  @for(nombreMes of nombres_mes; track nombreMes; let i = $index){
                    @if(analisis[0].check){<th class="stikyColum w3-border-right-balance" >{{nombreMes}}</th>}
                    @else{<th class="stikyColum w3-border-right-balance">mes {{i}}</th>}
                  }
                </tr>
              </thead>
              @for(element of dataSource2; track element; let i = $index){
                <tbody>
                  <tr class="w3-table-trtd w3-center borderInf">
                    <td class="borderAllLow marginsH alinLeft"> {{element.cosecha}} </td>
                    <td class="borderAllLow marginsH  w3-right-align"> {{formatearnormal(element.montocolocado)}} </td>
                    @for (mes of element.meses; track mes; let j = $index) {
                      <td style="width: 7%;" [class]="pintar(i,nPeriodosSel-1-j)" [ngStyle]="{'color': colorText(mes)}" class="borderAllLow marginsH w3-right-align">
                        <span class="w3-button">{{mes}} </span>
                      </td>
                    }                          
                  </tr>
                </tbody>
              }
            </table>
          </div>
        }
        @if (barras2Modal) {
          <div class="w3-rest w3-right w3-encabezado-table " style="height: 55vh; width: 100%;">
            <app-graficador 
              [etiquetas]="showLabels2"
              [data]="dataBarrasSald"
              [labels]="etiquetas2"
              [type]="tipoGraf"
              [axisX]="xAxisLabel"
              [axisY]="yAxisLabel2"
              [zona]="4"
              [colors]="colorScheme"
              [formatEtiquetas]="true"
              [changeLabel]="changeLabel2"
              [legend]="{enabled: true, position: 'right'}"
            ></app-graficador>
          </div>
        }  
        @if (barras1Modal) {
          <div class="w3-rest w3-right w3-encabezado-table " style="height: 55vh; width: 100%;">
            <app-graficador 
              [etiquetas]="showLabels"
              [data]="dataBarrasMor"
              [labels]="etiquetas"
              [type]="tipoGraf"
              [axisX]="xAxisLabel"
              [axisY]="yAxisLabel"
              [zona]="3"
              [colors]="colorScheme"
              [formatEtiquetas]="true"
              [changeLabel]="changeLabel"
              [legend]="{enabled: true, position: 'right'}"
            ></app-graficador>
          </div>
        }                
      </div>  
    </div>
</div>
</div>

<div id="modalTabla" class="w3-modal">
  <div class="w3-modal-content" style="width: 90%;">
    <div class="w3-row w3-titulo-contenidomenu w3-header-cuadrante bordeTest2">
      <div class="w3-twothird" style="height: 100% ; margin-top: 10px; margin-left: 20px;">
        <div class="hijoizquierdaTitle">
          <span class="w3-margin-left-contenido"><b>{{'riesgo-credito.cosechas.enc3' | translate}}</b></span><span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span><span class=" w3-margin-left-filter w3-subtitulo">{{subtituloCosechasClick}}</span>
        </div>
      </div>
      <div class="w3-rest w3-header-cuadrante padreizquierda" style="height: 6vh; margin-top: 10px; margin-left: 20px;">
        <div class="w3-right hijoderechaTitle" style="margin-right: 1vh;">
          <mat-icon class="iconoMen w3-button w3-dropdown-click" style="margin-right: 5px;" [ngStyle]="{'color':'gray'}" 
              (click)="exportar_cscClick()">description</mat-icon>
          <mat-icon (click)="cerrarAmp()" onclick="document.getElementById('modalTabla').style.display='none'" 
              class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}">clear</mat-icon>
        </div>
      </div>
    </div>
    <div class="w3-row" style="height: 65vh;">
      <div class="w3-row " style="height: 56vh; margin: 1vw;">
        <div class="w3-encabezado-table w3-scroll">
          <table class="w3-table">
            <thead>
              <tr class="w3-table-titleLow w3-center" style="line-height: 1.2;">
                <th class="stikyColum w3-border-right-balance">{{'riesgo-credito.cosechas.tit5' | translate}}</th>
                <th class="stikyColum w3-border-right-balance">{{'riesgo-credito.cosechas.tit6' | translate}}</th>
                <th class="stikyColum w3-border-right-balance">{{'riesgo-credito.cosechas.tit12' | translate}}</th>
                <th class="stikyColum w3-border-right-balance">{{'riesgo-credito.cosechas.tit7' | translate}}</th>
                <th class="stikyColum w3-border-right-balance">{{'riesgo-credito.cosechas.tit8' | translate}}</th>
                <th class="stikyColum w3-border-right-balance">{{'riesgo-credito.cosechas.tit13' | translate}}</th>
                <th class="stikyColum w3-border-right-balance">{{'riesgo-credito.cosechas.tit9' | translate}}</th>
                <th class="stikyColum w3-border-right-balance">{{'riesgo-credito.cosechas.tit10' | translate}}</th>
                <!-- <th class="stikyColum w3-border-right-balance">{{'riesgo-credito.cosechas.tit11' | translate}}</th> -->
              </tr>
            </thead>
            @for (element of dataCosechas; track element; let i = $index) {
              <tbody>
                <tr class="w3-table-trtd w3-center borderInf">
                  @if( i < dataCosechas.length-1){
                    <td class="borderAllLow marginsH"> {{element.nCred}} </td>
                    <td class="borderAllLow marginsH aligRight"> {{formatearnormal(element.cSocio)}} </td>
                    <td class="borderAllLow marginsH"> {{element.sucursal}} </td>
                    <td class="borderAllLow marginsH"> {{element.nom}} </td>
                    <td class="borderAllLow marginsH"> {{element.dMor}} </td>
                    <td class="borderAllLow marginsH"> {{element.tipo}} </td>
                    <td class="borderAllLow marginsH"> {{element.prod}} </td>
                    <td class="borderAllLow marginsH"> {{formatearnormal(element.sal)}} </td>
                  }@else{
                    <td class="borderAllLow marginsH" style="font-weight: bold;"> {{element.nCred}} </td>
                    <td class="borderAllLow marginsH aligRight" style="font-weight: bold;"> {{formatearnormal(element.cSocio)}} </td>
                    <td class="borderAllLow marginsH"> {{element.sucursal}} </td>
                    <td class="borderAllLow marginsH"> {{element.nom}} </td>
                    <td class="borderAllLow marginsH"> {{element.dMor}} </td>
                    <td class="borderAllLow marginsH"> {{element.tipo}} </td>
                    <td class="borderAllLow marginsH" style="font-weight: bold;"> {{element.prod}} </td>
                    <td class="borderAllLow marginsH" style="font-weight: bold;"> {{formatearnormal(element.sal)}} </td>
                  }                  
                  <!-- <td class="borderAllLow marginsH"> {{element.estatus}} </td> -->
                </tr>
              </tbody>
            }
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

